import React, { useCallback, useEffect, useRef, useState } from "react";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { getScheduledProducts } from "../../../../api/action/products";
import { editStudent, fetchStudent, register, signin } from "../../../../api/action/user";
import BackButton from "../components/CustomFields/BackButton";
import InstitutionHeader from "../components/InstitutionHeader";
import BackgroundComponent from "../components/theme/BackgroundAnimation";
import Loading from "../Enquiry/components/Loading";
import AdditionalDetails from "./components/AdditionalDetails";
import AddressDetails from "./components/AddressDetails";
import ContactPerson from "./components/ContactPerson";
import EducationDetails from "./components/EducationDetails";
import ParentDetails from "./components/ParentDetails";
import PersonalInfo from "./components/PersonalInfo";
import { setSelectedBranch } from "../../../../api/action/company";

const Button = ({ children, className = "", type = "button", ...props }) => (
  <button
    type={type}
    className={`rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-700 ${className}`}
    {...props}
  >
    {children}
  </button>
);

const Modal = ({ children, open }) => (open ? children : null);

const AdmissionForm = () => {
  const nav = useNavigate();
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const dispatch = useDispatch();
  const [validProducts, setValidProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const companyState = useSelector((state) => state.companyReducer.company);

  const selectedBranch = useSelector((state) => state.selectedBranch);

  const companyPrimaryId = companyState?.primaryId
  const branchPrimaryId = selectedBranch?.primaryId;

  const companyStoredData = companyState;
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const fetchStudentDataRef = useRef(null);

  useEffect(() => {
    const email = new URLSearchParams(location.search).get("email");

    if (email) {
      fetchStudentDataRef.current?.(email);
      setEdit(true);

    }
  }, [location.search]);
  useEffect(() => {
    if (snackbarMessage) {
      const timer = setTimeout(() => {
        setSnackbarMessage("");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [snackbarMessage, setSnackbarMessage]);
  const fetchStudentData = async (email) => {
    try {
      const response = await dispatch(fetchStudent({ email }));
      if (response.error) {
        setSnackbarMessage("Failed to fetch student details");
        setSnackbarSeverity("error");
      } else {
        setApplicant({
          firstName: response.firstName || "",
          primaryId: response.primaryId || "",
          lastName: response.lastName || "",
          email: response.email || "",
          phoneNumber: response.phoneNumber || "",
          dob: response.dob || "",
          userId: response.userId || "",
          userRole: response.userRole || "",
          status: response.status || "",
          gender: response.gender || "",
          addressList: response?.addressList || [
            {
              streetName1: "",
              city: "",
              state: "",
              zipcode: "",
              country: "",
            },
          ],
          educationDetails: response?.educationDetails || [
            { schoolName: "", degree: "" },
          ],
          contactPersonList: response?.contactPersonList || [
            {
              firstName: "",
              lastName: "",
              email: "",
              phoneNumber: "",
              type: "FATHER",
            },
          ],
          parentList: response?.parentList || [
            {
              firstName: "",
              lastName: "",
              email: "",
              phoneNumber: "",
              occupation: "",
              annualIncome: "",
            },
          ],
          dynamicAttributes: response?.dynamicAttributes || [
            { name: "Nationality", value: "" },
            { name: "Community", value: "" },
            { name: "Language", value: "" },
            { name: "Stream", value: "" },
            { name: "class", value: "" },
            { name: "How did you know about Velammal", value: "" },
          ],
        });
      }
    } catch (error) {
      setSnackbarMessage("An error occurred while fetching student details");
      setSnackbarSeverity("error");
    }
  };
  fetchStudentDataRef.current = fetchStudentData;
  const handleModalClose = () => {
    setOpenModal(false);
    nav("/enquiry");
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const [company, setCompany] = useState(null);

  const branchField = companyStoredData?.hasBranch;
  const [applicant, setApplicant] = useState({
    createdBy: "Praveen",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    dob: "",
    gender: "",
    status: "ACTIVE",
    countryCode: "91",
    password: "",
    confirmPassword: "",
    addressList: [
      {
        streetName1: "",
        streetName2: "",
        city: "",
        state: "",
        zipcode: "",
        country: "",
        type: "HOME",
      },
    ],
    educationDetails: [
      {
        schoolName: "",
        degree: "",
        currentlyStudying: false,
        startDate: "",
        endDate: "",
      },
    ],
    dynamicAttributes: branchField
      ? [
        { name: "Nationality", value: "" },
        { name: "Community", value: "" },
        { name: "Language", value: "" },
        { name: "Stream", value: "" },
        { name: "class", value: "" },
        { name: "Branch", value: "" },
      ]
      : [
        { name: "Nationality", value: "" },
        { name: "Community", value: "" },
        { name: "Language", value: "" },
        { name: "Stream", value: "" },
        { name: "class", value: "" },
      ],
    company: {
      primaryId: localStorage.getItem("selectedBranchPrimaryId") || branchPrimaryId || companyPrimaryId,
      domain: { type: "INSTITUTION" },
    },
    userRoles: ["APPLICANT"],
    userRole: "APPLICANT",
    contactPersonList: [
      {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        isPrimary: true,
        type: "FATHER",
      },
    ],
    parentList: [
      {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        occupation: "",
        annualIncome: "",
        type: "MOTHER",
      },
      {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        occupation: "",
        annualIncome: "",
        type: "FATHER",
      },
    ],
  });
  const getCurrentPrimaryId = useCallback(() => {
    return localStorage.getItem("selectedBranchPrimaryId") || branchPrimaryId || companyPrimaryId;
  }, [branchPrimaryId, companyPrimaryId]);

  useEffect(() => {
    // Get stored branch primary ID from localStorage
    const storedBranchPrimaryId = localStorage.getItem("selectedBranchPrimaryId");
    const storedBranch = localStorage.getItem("selectedBranch");

    if (branchPrimaryId) {
      // Use Redux state if available
      setCompany(selectedBranch);
      setApplicant((prevState) => ({
        ...prevState,
        company: {
          ...prevState.company,
          primaryId: branchPrimaryId,
          domain: { type: selectedBranch.domain.type },
        },
      }));
    } else if (storedBranchPrimaryId && storedBranch) {
      // Fall back to localStorage if Redux state is not available
      const branchObj = JSON.parse(storedBranch);
      setCompany(branchObj);
      dispatch(setSelectedBranch(branchObj)); // Update Redux state
      setApplicant((prevState) => ({
        ...prevState,
        company: {
          ...prevState.company,
          primaryId: storedBranchPrimaryId,
          domain: { type: branchObj.domain.type },
        },
      }));
    } else if (companyPrimaryId) {
      // Use company primary ID as fallback
      setApplicant((prevState) => ({
        ...prevState,
        company: {
          ...prevState.company,
          primaryId: companyPrimaryId,
          domain: { type: "INSTITUTION" },
        },
      }));
    }
  }, [branchPrimaryId, selectedBranch, companyPrimaryId, dispatch]);

  useEffect(() => {
    let count = 0;

    if (applicant.firstName) count++;
    if (applicant.lastName) count++;
    if (applicant.email) count++;
    if (applicant.phoneNumber) count++;
    if (applicant.dob) count++;
    if (applicant.gender) count++;
    if (!edit && applicant.password) count++;
    if (!edit && applicant.confirmPassword) count++;

    applicant.addressList.forEach(address => {
      if (address.streetName1) count++;
      if (address.city) count++;
      if (address.state) count++;
      if (address.zipcode) count++;
      if (address.country) count++;
    });

    applicant.contactPersonList.forEach(contact => {
      if (contact.firstName) count++;
      if (contact.lastName) count++;
      if (contact.email) count++;
      if (contact.phoneNumber) count++;
    });

    applicant.educationDetails.forEach(edu => {
      if (edu.schoolName) count++;
      if (edu.degree) count++;
    });

    applicant.parentList.forEach(parent => {
      if (parent.firstName) count++;
      if (parent.lastName) count++;
      if (parent.email) count++;
      if (parent.phoneNumber) count++;
      if (parent.occupation) count++;
      if (parent.annualIncome) count++;
    });

    applicant.dynamicAttributes.forEach(attr => {
      if (attr.value) count++;
    });

    sessionStorage.setItem('filledFieldsCount', count.toString());
  }, [applicant, edit]);


  useEffect(() => {
    return () => {
      sessionStorage.removeItem('filledFieldsCount');
    };
  }, []);

  const handleChange = (field, value) => {
    // Clear the error for this field when it's changed
    setErrors(prev => ({
      ...prev,
      [field]: undefined
    }));

    setApplicant(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleNestedChange = (parentKey, index, fieldKey, newValue) => {
    // Clear nested errors when a field is changed
    setErrors(prev => {
      const updatedErrors = { ...prev };

      if (
        updatedErrors[parentKey] &&
        Array.isArray(updatedErrors[parentKey]) &&
        index !== null &&
        updatedErrors[parentKey][index]
      ) {
        const parentErrors = [...updatedErrors[parentKey]];

        if (parentErrors[index] && parentErrors[index][fieldKey]) {
          parentErrors[index] = {
            ...parentErrors[index],
            [fieldKey]: undefined,
          };

          if (Object.values(parentErrors[index]).every(val => val === undefined)) {
            parentErrors[index] = null;
          }

          updatedErrors[parentKey] = parentErrors.filter(error => error !== null);

          if (updatedErrors[parentKey].length === 0) {
            delete updatedErrors[parentKey];
          }
        }
      }

      return updatedErrors;
    });

    setApplicant(prev => {
      const updated = { ...prev };

      // 🔄 Case 1: update a single field in an array item
      if (
        Array.isArray(updated[parentKey]) &&
        index !== null &&
        fieldKey !== null
      ) {
        const listCopy = [...updated[parentKey]];
        listCopy[index] = {
          ...listCopy[index],
          [fieldKey]: newValue,
        };
        updated[parentKey] = listCopy;

        // 🔄 Case 2: replace the full array (e.g., on add/remove)
      } else if (Array.isArray(newValue)) {
        updated[parentKey] = newValue;

        // ❗Optionally handle other types of nested updates here
      } else {
        updated[parentKey] = newValue;
      }

      return updated;
    });
  };

  const fetchCount = useRef(0);

  useEffect(() => {
    const fetchValidProducts = async () => {
      const currentPrimaryId = getCurrentPrimaryId();

      if (!currentPrimaryId || fetchCount.current >= 1) return;

      try {
        const payload = {
          company: { primaryId: companyPrimaryId },
          product: {
            type: {
              typeCode: "APPLICATION"
            },
          },
          status: "IN_PROGRESS",
          hasChild: true,
        };

        const productsResponse = await getScheduledProducts(payload)(dispatch);

        const filteredProducts = Array.isArray(productsResponse) ? productsResponse : [];

        setValidProducts(filteredProducts);

        fetchCount.current += 1;
      } catch {
        setValidProducts([]);
      }
    };

    fetchValidProducts();
  }, [branchPrimaryId, companyPrimaryId, dispatch, getCurrentPrimaryId]);

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const [errors, setErrors] = useState({});
  const personalInfoRef = useRef(null);
  const additionalDetailsRef = useRef(null);
  const addressDetailsRef = useRef(null);
  const contactPersonRef = useRef(null);
  const educationDetailsRef = useRef(null);
  const parentDetailsRef = useRef(null);

  const validateFields = () => {
    const newErrors = {};
    let firstErrorSection = null;

    // Validate basic applicant fields
    const hasPersonalInfoErrors = !applicant.firstName || !applicant.lastName || !applicant.email ||
      !applicant.phoneNumber || !applicant.dob || !applicant.gender ||
      (!edit && (!applicant.password || !applicant.confirmPassword));

    if (!applicant.firstName) newErrors.firstName = "First Name is required";
    if (!applicant.lastName) newErrors.lastName = "Last Name is required";
    if (!applicant.email) newErrors.email = "Email is required";
    if (!applicant.phoneNumber) newErrors.phoneNumber = "Mobile Number is required";
    if (!applicant.dob) newErrors.dob = "Date of Birth is required";
    if (!applicant.gender) newErrors.gender = "Gender is required";
    if (!edit && !applicant.password) newErrors.password = "Password is required";
    if (!edit && !applicant.confirmPassword) newErrors.confirmPassword = "Confirm Password is required";

    // //   Add this check
    // if (!applicant.class) {
    //   newErrors.registrationClass = "Class is required";
    //   if (!firstErrorSection) firstErrorSection = personalInfoRef;
    // }

    if (hasPersonalInfoErrors && !firstErrorSection) firstErrorSection = personalInfoRef;

    // Check additional details errors (assuming dynamic attributes section)
    const hasAdditionalDetailsErrors = applicant.dynamicAttributes.some(attr => !attr.value);
    if (hasAdditionalDetailsErrors && !firstErrorSection) firstErrorSection = additionalDetailsRef;

    // Validate addressList fields
    newErrors.addressList = applicant.addressList.map((address) => {
      const addressErrors = {};
      if (!address.streetName1) addressErrors.streetName1 = "Street Name 1 is required";
      if (!address.country) addressErrors.country = "Country is required";
      if (!address.state) addressErrors.state = "State is required";
      if (!address.city) addressErrors.city = "City is required";
      if (!address.zipcode) addressErrors.zipcode = "Pincode is required";
      return Object.keys(addressErrors).length > 0 ? addressErrors : null;
    }).filter(error => error !== null);

    if (newErrors.addressList && newErrors.addressList.length > 0 && !firstErrorSection) {
      firstErrorSection = addressDetailsRef;
    }
    if (newErrors.addressList.length === 0) delete newErrors.addressList;

    // Validate contactPersonList fields
    newErrors.contactPersonList = applicant.contactPersonList.map((contact) => {
      const contactErrors = {};
      if (!contact.firstName) contactErrors.firstName = "First Name is required";
      if (!contact.lastName) contactErrors.lastName = "Last Name is required";
      if (!contact.email) contactErrors.email = "Email is required";
      if (!contact.phoneNumber) contactErrors.phoneNumber = "Mobile Number is required";
      return Object.keys(contactErrors).length > 0 ? contactErrors : null;
    }).filter(error => error !== null);

    if (newErrors.contactPersonList && newErrors.contactPersonList.length > 0 && !firstErrorSection) {
      firstErrorSection = contactPersonRef;
    }
    if (newErrors.contactPersonList.length === 0) delete newErrors.contactPersonList;

    // Validate educationDetails fields
    newErrors.educationDetails = applicant.educationDetails.map((education) => {
      const educationErrors = {};
      if (!education.schoolName) educationErrors.schoolName = "School Name is required";
      if (!education.degree) educationErrors.degree = "Board selection is required";
      if (education.degree === "Others" && !education.otherBoard) {
        educationErrors.otherBoard = "Other Board Name is required";
      }
      return Object.keys(educationErrors).length > 0 ? educationErrors : null;
    }).filter(error => error !== null);

    if (newErrors.educationDetails && newErrors.educationDetails.length > 0 && !firstErrorSection) {
      firstErrorSection = educationDetailsRef;
    }
    if (newErrors.educationDetails.length === 0) delete newErrors.educationDetails;

    // Set the errors
    setErrors(newErrors);

    // Scroll to the first error section if there is one
    if (firstErrorSection && firstErrorSection.current) {
      // Force the scroll to happen after the DOM updates with errors
      setTimeout(() => {
        window.scrollTo({
          top: firstErrorSection.current.offsetTop - 100,
          behavior: 'smooth'
        });
      }, 100);
    }

    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    setLoading(true);
    if (
      !applicant.firstName ||
      !applicant.lastName ||
      !applicant.email ||
      !applicant.phoneNumber ||
      !applicant.dob
    ) {
      setSnackbarMessage("All fields are required.");
      setSnackbarSeverity("error");
      setLoading(false);
      return;
    }

    if (!validateEmail(applicant.email)) {
      setSnackbarMessage("Invalid email format.");
      setSnackbarSeverity("error");
      setLoading(false);
      return;
    }
    const sanitizedPhoneNumber = applicant.phoneNumber.replace(/[^\d]/g, "");
    const formattedPhoneNumber =
      sanitizedPhoneNumber.startsWith("91") ? sanitizedPhoneNumber : `91${sanitizedPhoneNumber}`;

    setApplicant((prev) => ({
      ...prev,
      phoneNumber: formattedPhoneNumber,
    }));

    if (applicant.password !== applicant.confirmPassword) {
      setSnackbarMessage("Passwords do not match.");
      setSnackbarSeverity("error");
      setLoading(false);
      return;
    }

    try {
      let response;
      if (edit) {
        response = await dispatch(editStudent({ ...applicant, phoneNumber: formattedPhoneNumber }));
        setSnackbarMessage("Student information updated successfully!");
        setSnackbarSeverity("success");

        window.location.href = "/additional-info";
      } else {
        response = await dispatch(register({ ...applicant, phoneNumber: formattedPhoneNumber }));
        setSnackbarMessage("Application submitted successfully!");
        setSnackbarSeverity("success");
        // const companyJson = activeEntity;
        // const companyCode = companyJson.code;

        if (response) {
          const { userRole, email, primaryId, message } = response;
          const backendErrorMessage =
            message || "An error occurred. Please try again later.";

          if (userRole === "APPLICANT") {
            localStorage.setItem("email", email);
            localStorage.setItem("userId", primaryId);
            setTimeout(async () => {
              const loginResponse = await dispatch(
                signin({ email, password: applicant.password, company: { primaryId: branchPrimaryId } })
              );
              nav("/additional-info");

              if (loginResponse.jwtResponse && loginResponse.jwtResponse.jwtToken) {
                localStorage.setItem("token", loginResponse.jwtResponse.jwtToken);

                const userRole = loginResponse.userDetails.userRole;
                localStorage.setItem("userRole", userRole);

                if (userRole === "APPLICANT") {
                  window.location.href = "/additional-info";
                }
              } else {
                setSnackbarMessage(
                  "Login failed after registration. Please try again."
                );
                setSnackbarSeverity("error");
              }
            }, 1000);
          } else if (backendErrorMessage.includes("A user with email")) {
            setSnackbarMessage("Email already taken. Please use a different email.");
            setSnackbarSeverity("error");
          }
        } else {
          const backendErrorMessage =
            response?.message || "An error occurred. Please try again later.";
          if (backendErrorMessage.includes("A user with email")) {
            setSnackbarMessage("Email already taken. Please use a different email.");
            setSnackbarSeverity("error");
          } else {
            setSnackbarMessage(backendErrorMessage);
            setSnackbarSeverity("error");
          }
        }
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || "An error occurred. Please try again later.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      {loading && <Loading message="Submitting your application..." />}

      {snackbarMessage && (
        <div
          className={`fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-lg text-white flex items-center space-x-3 z-50 ${snackbarSeverity === "success" ? "bg-green-500" : "bg-red-500"
            }`}
        >
          {snackbarSeverity === "success" ? (
            <AiOutlineCheckCircle className="text-xl" />
          ) : (
            <AiOutlineCloseCircle className="text-xl" />
          )}

          <span>{snackbarMessage}</span>
        </div>
      )}

      <div
        style={{
          minHeight: "100vh",
          overflow: "hidden",
          background: "linear-gradient(to bottom right, #3182ce, #4c51bf)",
          position: "relative",
        }}
      >
        <div style={{ position: "relative", zIndex: 20 }}>
          <InstitutionHeader />
        </div>

        <br />

        <BackgroundComponent />
        <div
          style={{
            position: "relative",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "auto",
            padding: "40px",
            top: "50px"
          }}
        >
          <div style={{ position: "absolute", top: "30px", left: "20px", zIndex: 50 }}>
            <BackButton />
          </div>
          <div
            style={{
              width: "100%",
              maxWidth: "800px",
              margin: "0 auto",
              padding: "40px",
              background: "rgba(255, 255, 255, 0.9)",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              overflowY: "auto",
            }}
          >
            <h2
              style={{
                fontSize: "24px",
                fontWeight: "600",
                textAlign: "center",
                marginBottom: "24px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <span>Online Application Registration</span>
            </h2>

            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
              <div ref={personalInfoRef} style={{ border: "1px solid #e2e8f0", padding: "24px", borderRadius: "8px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <PersonalInfo
                  company={company}
                  applicant={applicant}
                  handleChange={handleChange}
                  handleNestedChange={handleNestedChange}
                  validProducts={validProducts}
                  edit={edit}
                  handleModalOpen={handleModalOpen}
                  errors={errors}
                />
              </div>
              <div ref={additionalDetailsRef} style={{ border: "1px solid #e2e8f0", padding: "24px", borderRadius: "8px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <AdditionalDetails
                  applicant={applicant}
                  handleChange={handleChange}
                  handleNestedChange={handleNestedChange}
                  validProducts={validProducts}
                  handleModalOpen={handleModalOpen}
                  errors={errors}
                />
              </div>
              <div ref={addressDetailsRef} style={{ border: "1px solid #e2e8f0", padding: "24px", borderRadius: "8px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <AddressDetails
                  applicant={applicant}
                  handleNestedChange={handleNestedChange}
                  errors={errors}
                />
              </div>
              <div ref={contactPersonRef} style={{ border: "1px solid #e2e8f0", padding: "24px", borderRadius: "8px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <ContactPerson
                  applicant={applicant}
                  handleNestedChange={handleNestedChange}
                  errors={errors}
                />
              </div>
              <div ref={educationDetailsRef} style={{ border: "1px solid #e2e8f0", padding: "24px", borderRadius: "8px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <EducationDetails
                  applicant={applicant}
                  handleNestedChange={handleNestedChange}
                  errors={errors}
                />
              </div>
              <div ref={parentDetailsRef} style={{ border: "1px solid #e2e8f0", padding: "24px", borderRadius: "8px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <ParentDetails
                  applicant={applicant}
                  handleNestedChange={handleNestedChange}
                  errors={errors}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {!edit ? (
                  <button
                    type="submit"
                    style={{
                      width: "50%",
                      background: "linear-gradient(to right, #4299e1, #667eea)",
                      color: "#fff",
                      padding: "12px 0",
                      borderRadius: "8px",
                      fontWeight: "600",
                      textAlign: "center",
                      transition: "background 0.3s",
                    }}
                  >
                    Save & Next
                  </button>
                ) : (
                  <button
                    type="submit"
                    style={{
                      width: "50%",
                      background: "linear-gradient(to right, #4299e1, #667eea)",
                      color: "#fff",
                      padding: "12px 0",
                      borderRadius: "8px",
                      fontWeight: "600",
                      textAlign: "center",
                      transition: "background 0.3s",
                    }}
                  >
                    Update & Next
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      <Modal open={openModal} onClose={handleModalClose}>
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="modal-content bg-[#f9f9f9] p-6 rounded-md shadow-lg max-w-md mx-auto">
            <h2 className="text-lg font-semibold text-center mb-4">
              Online application for the selected class is currently disabled.
            </h2>
            <p className="text-center mb-4">
              Please contact us if you have any queries or submit an enquiry.
            </p>
            <Button onClick={handleModalClose} className="self-center">
              Close
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AdmissionForm;
